 import { Breakpoints as Breakpoint } from './settings';
 import * as LazyLoad from './vendor/jquery.lazyload';

( function( $ ) {

    // Lazy load images
    lazyImages();

    $(window).resize(function() {

      lazyImages();

    });

    // Reveal divs on scroll
    $(window).scroll(function() {

        //lazyReveal();
      
    });
    
    /**
     * Lazy load images
     */
    function lazyImages() {

      $('[data-lazy], .lazy').lazyload({
        threshold: 550,
        //effect : 'fadeIn'
      });

      // -- Lazy Init
      if( Breakpoint.mdUp() ) {

        $('[data-lazy="md-up"]').lazyload({
          threshold: 550,
          //effect : 'fadeIn'
        });

      }

      // -- Reveal lazies on load
      $(window).trigger( 'scroll' );

    }

    /**
     * Menu Item Events
     */
    function menuItemEvents() {

        toggleSubmenus();

        /**
         * Toggle Submenus
         */
        function toggleSubmenus() {

            $('.js-mmenu-sub-trigger').on( 'click', function( event ) {

                event.preventDefault();

                var $subItems = $(this).next( '.main-item-submenu' );
                var $otherItems = $('.js-mmenu-sub-trigger').not( this ).next( '.main-item-submenu' );

                // Make sure other guys are closed
                $otherItems.removeClass( 'is-collapsed' );

                // Toggle this guy
                $subItems.toggleClass( 'is-collapsed' );


            } );
        }

    }




} )( jQuery );


// WEBPACK FOOTER //
// ./assets/frontend/scripts/main/lazies.js